<template>
  <v-row>
    <v-col cols="12">
      <div><strong>{{qtdResponsaveisSelecionados}}</strong></div>
      <v-divider/>
    </v-col>    
    <v-col cols="12" md="12">
      <v-text-field 
          label="Informe um assunto para essa(s) mensagem(ns)"
          dense
          value=""
          v-model.trim="value.descricao"
          :rules="[
                      this.$validators.string.required
                  ]"/>
    </v-col>
    <v-col cols="12" sm="4" >
      <v-radio-group v-model="value.vaiEnviarImagem" row 
          :rules="[
                this.$validators.string.required,
          ]">
        <v-radio
          label="Sem anexo"
          value="N"
        ></v-radio>
        <v-radio
          label="Com anexo"
          value="S"
        ></v-radio>        
      </v-radio-group>
    </v-col>
    <v-col cols="12" md="8" v-show="value.vaiEnviarImagem=='S'">
      <v-file-input
        accept=".jpg, .jpeg, .png"
        :label="'Escolha uma imagem de capa de até ' + this.tamanhoImg + 'MB'"
        v-model="value.caminhoImagem"
        :rules="[
            v => this.$validators.number.tamanhoMaxArquivo(v, this.tamanhoImg)
          ]"
        ></v-file-input>
    </v-col>
    <v-col cols="12">
      <v-textarea
          label="Texto da mensagem"
          counter
          filled
          prepend-icon="mdi-comment"
          rows="7"
          v-model="value.mensagem" 
          :rules="[
                      this.$validators.string.required
                  ]"
        ></v-textarea>
    </v-col>
    <v-col cols="12" class="text-caption">
      <v-divider/>
      <div>Ao programar o envio da(s) mensagens(s), você poderá usar uma ou mais chaves abaixo e o sistema substituirá automaticamente pelo valor correspondente a cada linha marcada</div>
      <ul>
        <li>{nome} - Nome do Responsável pela empresa</li>
        <li>{fornecedor} - Nome da Empresa Fornecedora</li>
        <li>{comprador} - Nome da Empresa Compradora</li>
      </ul>
      <v-divider/>
    </v-col>
  </v-row>
</template>

<script>
import {ItemDeDominio} from "../../../api/itemsDominio";
import LookupDominio from "../common/LookupDominio";
import SearchBox from "../common/SearchBox";
import Vue from 'vue';

export default {
  name: "MensagemForm",
  components: {SearchBox, LookupDominio},
  props: {
    value: {
      type: Object
    },
    responsaveisSelecionados: {
      type: Array
    },
    searchValues: {
      type: Object
    }
  },
  data() {
    return {
      lookups: {
      },
      mensagemTipo7: `Olá {nome}...`,
      tamanhoImg: 1
    }
  },
  computed: {
    qtdResponsaveisSelecionados() {
      return "" + this.responsaveisSelecionados.length + " responsável(eis) selecionado(s).";
    },
  },
  methods: { 
    setTextoMensagem() {
      Vue.set(this.value,'mensagem',this.mensagemTipo7);
    },
    setVaiEnviarImagem() {
      Vue.set(this.value,'vaiEnviarImagem','N');
    },
  },
  mounted(){
    this.setTextoMensagem();
    this.setVaiEnviarImagem();
  }
}
</script>

<style scoped>

</style>